// extracted by mini-css-extract-plugin
module.exports = {"head":"Services_head__1sCYr","stage":"Services_stage__30bjX","title":"Services_title__2zD0h","list":"Services_list__3e3Wz","item":"Services_item__17oF4"};